// Hindi
export const hi = {
  'app.name':           'Kardolive',
  'app.tagline':        'ग्राहक पोर्टल',
  'app.signOut':        'साइन आउट',

  'login.email':        'ईमेल',
  'login.password':     'पासवर्ड',
  'login.signIn':       'साइन इन करें',
  'login.signingIn':    'साइन इन हो रहा है…',
  'login.failed':       'साइन इन विफल',
  'login.newAccount':   'Kardolive पर नए हैं?',
  'login.createAccount':'मुफ़्त खाता बनाएं →',

  'nav.workspace':      'वर्कस्पेस',
  'nav.templates':      'टेम्पलेट',
  'nav.live':           'लाइव',
  'nav.rooms':          'रूम और चैट',
  'nav.content':        'सामग्री',
  'nav.developer':      'डेवलपर',
  'nav.account':        'खाता',

  'nav.overview':       'सारांश',
  'nav.projects':       'परियोजनाएं',
  'nav.chat':           'चैट कंसोल',
  'nav.sessions':       'सत्र',
  'nav.streams':        'लाइव स्ट्रीम',
  'nav.studio':         'स्टूडियो',
  'nav.recordings':     'रिकॉर्डिंग',
  'nav.apiKeys':        'API कुंजियाँ',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook परीक्षक',
  'nav.networkTest':    'नेटवर्क परीक्षण',
  'nav.embed':          'एम्बेड विजेट',
  'nav.sdk':            'SDK और दस्तावेज़',
  'nav.docs':           'डेवलपर डॉक्स',
  'nav.analytics':      'विश्लेषण',
  'nav.settings':       'सेटिंग्स',

  'overview.welcome':       'वापस स्वागत है, {name}',
  'overview.plan':          '{tenant} · {plan} योजना',
  'overview.newStream':     'नई स्ट्रीम',
  'overview.kpi.live':           'अभी लाइव',
  'overview.kpi.live.broadcasting': 'स्ट्रीम प्रसारित हो रहीं हैं',
  'overview.kpi.live.nothing':    'कुछ भी लाइव नहीं',
  'overview.kpi.total':           'कुल स्ट्रीम',
  'overview.kpi.total.sub':       'सभी समय में',
  'overview.kpi.sessions':        'सत्र · 30 दिन',
  'overview.kpi.sessions.sub':    'प्रकाशन घटनाएँ',
  'overview.kpi.recordings':      'रिकॉर्डिंग',
  'overview.kpi.recordings.sub':  'चलाने के लिए तैयार',
  'overview.recentStreams':       'हालिया स्ट्रीम',
  'overview.recentSessions':      'हालिया सत्र',
  'overview.viewAll':             'सभी देखें →',
  'overview.empty.title':         'अभी तक कोई स्ट्रीम नहीं',
  'overview.empty.body':          'प्रसारण शुरू करने के लिए अपनी पहली स्ट्रीम बनाएँ।',
  'overview.empty.action':        'स्ट्रीम बनाएँ',
  'overview.noSessions':          'अभी तक कोई सत्र नहीं',

  'status.live':        'लाइव',
  'status.idle':        'निष्क्रिय',
  'status.ended':       'समाप्त',
  'status.archived':    'संग्रहीत',

  'common.save':        'सहेजें',
  'common.cancel':      'रद्द करें',
  'common.delete':      'हटाएँ',
  'common.edit':        'संपादित करें',
  'common.create':      'बनाएँ',
  'common.confirm':     'पुष्टि करें',
  'common.loading':     'लोड हो रहा है…',
  'common.error':       'त्रुटि',
  'common.retry':       'पुनः प्रयास करें',

  // Dashboard navigation and account controls.
  "nav.skipContent": "पृष्ठ की सामग्री पर जाएँ",
  "nav.streamTemplates": "स्ट्रीम टेम्पलेट",
  "nav.boards": "इंटरैक्टिव बोर्ड",
  "nav.menu": "नेविगेशन खोलें",
  "nav.closeMenu": "नेविगेशन बंद करें",
  "nav.scenarios": "उपयोग के परिदृश्य",
  "nav.premieres": "प्रीमियर",
  "nav.clips": "क्लिप",
  "dashboard.account": "खाता",
  "dashboard.language": "भाषा",
  "dashboard.appearance": "रंग-रूप",
  "nav.allStreams": "सभी स्ट्रीम",
  "nav.destinations": "प्रसारण गंतव्य",
  "nav.ecommerce": "ई-कॉमर्स",
  "nav.products": "उत्पाद",
  "nav.services": "सेवाएँ",
  "nav.collections": "संग्रह",
  "nav.orders": "ऑर्डर",
  "nav.commerceSettings": "व्यापार सेटिंग",
  "nav.engagement": "सहभागिता",
  "theme.light": "हल्के मोड में जाएँ",
  "theme.dark": "गहरे मोड में जाएँ",
  "role.owner": "मालिक",
  "role.admin": "प्रशासक",
  "role.member": "सदस्य",
  "role.viewer": "दर्शक",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "सक्रिय",
  "streams.archived": "संग्रहीत",
  "streams.monitor": "स्रोत मॉनिटर",
  "streams.create": "लाइव स्ट्रीम बनाएँ",
  "streams.list": "सूची",
  "streams.grid": "ग्रिड",
  "streams.view": "स्ट्रीम दृश्य",
  "streams.searchLabel": "इवेंट खोजें",
  "streams.searchHint": "इवेंट का नाम खोजें",
  "streams.solutionFilter": "प्रकार के अनुसार इवेंट फ़िल्टर करें",
  "streams.statusFilter": "स्थिति के अनुसार इवेंट फ़िल्टर करें",
  "streams.dateFilter": "बनाने की तारीख के अनुसार फ़िल्टर करें",
  "streams.allSolutions": "सभी प्रकार",
  "streams.custom": "मौजूदा या कस्टम सेटअप",
  "streams.allStatuses": "सभी स्थितियाँ",
  "streams.anyTime": "बनाने की कोई भी तारीख",
  "streams.last7": "पिछले 7 दिनों में बनाए गए",
  "streams.last30": "पिछले 30 दिनों में बनाए गए",
  "streams.count": "{total} में से {shown} इवेंट दिखाए जा रहे हैं",
  "streams.noMatch": "फ़िल्टर से मेल खाने वाला कोई इवेंट नहीं मिला।",
  "streams.clearFilters": "फ़िल्टर हटाएँ",
  "streams.refreshFailed": "स्ट्रीम सूची रीफ़्रेश नहीं हो सकी",
  "streams.loadFailed": "स्ट्रीम लोड नहीं हो सकीं",
  "streams.stale": "पिछली लोड की गई सूची दिखाई जा रही है। स्थितियाँ बदल सकती हैं।",
  "streams.connectionHint": "कनेक्शन जाँचें और सूची फिर से लोड करें।",
  "streams.retrying": "फिर से कोशिश हो रही है…",
  "streams.retry": "फिर कोशिश करें",
  "streams.restoreFailed": "स्ट्रीम बहाल नहीं हो सकी",
  "streams.restoreHint": "फिर कोशिश करने से पहले कनेक्शन जाँचें और नवीनतम स्थिति के लिए सूची रीफ़्रेश करें।",
  "streams.unused": "इस्तेमाल नहीं की गई स्ट्रीम: {count}",
  "streams.unusedHint": "कोई प्रसारण या रीप्ले नहीं है। सूची व्यवस्थित करने के लिए इन्हें संग्रह में रखें; कुछ भी मिटाया नहीं जाएगा।",
  "streams.reviewArchive": "समीक्षा करें और संग्रह में रखें",
  "streams.loading": "स्ट्रीम लोड हो रही हैं…",
  "streams.archiveEmpty": "कोई संग्रहीत स्ट्रीम नहीं है। संग्रहीत स्ट्रीम और उनके रीप्ले बहाल किए जाने तक यहाँ रहते हैं।",
  "streams.restore": "बहाल करें",
  "streams.firstTitle": "अपनी पहली स्ट्रीम बनाएँ",
  "streams.firstBody": "बिक्री, कक्षा या सेवा के लिए सेटअप चुनें या खाली स्ट्रीम से शुरू करें। ब्राउज़र, फ़ोन या OBS से प्रसारण करें।",
  "streams.blank": "खाली स्ट्रीम",
  "streams.broadcasts": "प्रसारण: {count}",
  "streams.replays": "रीप्ले: {count}",
  "streams.sessions": "सत्र: {count}",
  "streams.recordings": "रिकॉर्डिंग: {count}",
  "streams.mode.BROADCAST": "प्रसारण",
  "streams.mode.LOW_LATENCY": "कम विलंबता",
  "streams.mode.REALTIME": "रीयल-टाइम",
  "streams.key": "कुंजी",
  "streams.archiveTitle": "इस्तेमाल नहीं की गई स्ट्रीम संग्रह में रखें",
  "streams.archiveHint": "ये स्ट्रीम कभी प्रसारित नहीं हुई हैं। संग्रहीत टैब से इन्हें किसी भी समय बहाल कर सकते हैं।",
  "streams.archiveFailed": "{count} स्ट्रीम संग्रह में नहीं रखी जा सकीं; शायद वे लाइव हो गई हों। बाकी संग्रह में रख दी गई हैं।",
  "streams.archiving": "संग्रह में रखा जा रहा है…",
  "streams.archiveCount": "{count} संग्रह में रखें",
  "streamType.webinar": "व्यावसायिक वेबिनार और लॉन्च",
  "streamType.classroom": "कक्षाएँ और ट्यूशन",
  "streamType.training": "कॉर्पोरेट प्रशिक्षण",
  "streamType.conference": "सम्मेलन और प्रदर्शनियाँ",
  "streamType.shopping": "लाइव खरीदारी",
  "streamType.auction": "लाइव नीलामी",
  "streamType.consultation": "निजी परामर्श",
  "streamType.creator": "क्रिएटर और समुदाय की लाइव स्ट्रीम",
  "streamType.audio": "ऑडियो रूम और पॉडकास्ट",
  "streamType.sports": "खेल और ई-स्पोर्ट्स",
  "streamType.performance": "संगीत कार्यक्रम और प्रस्तुतियाँ",
  "streamType.community": "उपासना और धन-संग्रह",
  "streamType.tour": "दौरे और प्रदर्शन",
  "streamType.fitness": "फ़िटनेस और कार्यशालाएँ",
  "streamType.public-meeting": "समाचार और सार्वजनिक बैठकें",
  "streamType.continuous": "निरंतर चैनल और कैमरे",
  "streams.close": "बंद करें",
};
